import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {TagConfig} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';

export default function tasktagsreducer(state = initialstate.taskTags, action) {
	switch (action.type) {
		case types.GET_TASK_TAGS: {
			// get task tags for deep link task url
			let resposnse = Utility.getSortedData(
				action.response?.data,
				TagConfig.groupByAttributeMapping,
				TagConfig.outputAttributesName
			);
			return {
				tags: resposnse
			};
		}
		case types.RESET_TASK_TAGS:
		case types.RESET_TASK_DETAIL:
		case types.RESET_TASK_ATTRIBUTES: {
			return initialstate.taskTags;
		}
		case types.UPDATE_TASK_TAGS: {
			return {
				...state,
				tags: Utility.getSortedData(
					action.payload.taskTags,
					TagConfig.groupByAttributeMapping,
					TagConfig.outputAttributesName
				)
			};
		}
		case types.ASSOCIATE_TASK_TAG: {
			if (state.tags && !action.error) {
				if (action.payload.operation == 'Add') {
					let entityUId =
						_.size(action.payload.entitiesUIds) > 0 ? action.payload.entitiesUIds[0] : action.payload.entitiesUIds;
					let tagList = [...state.tags, buildTag(action.payload.tag, action.payload.tagGroup, entityUId)];
					return {
						...state,
						tags: Utility.getSortedData(tagList, TagConfig.groupByAttributeMapping, TagConfig.outputAttributesName)
					};
				}

				if (action.payload.operation == 'Remove') {
					let tagList = state.tags.filter((tagItem) => {
						return tagItem.engagementTagId != action.payload.tag.tagId;
					});

					return {
						...state,
						tags: tagList
					};
				}
			}

			return state;
		}
		case types.DISASSOCIATE_TASK_TAG: {
			if (state.tags && !action.error) {
				let tagList = state.tags.filter((tagItem) => {
					return tagItem.engagementTagId != action.payload.tag.tagId;
				});

				return {
					...state,
					tags: tagList
				};
			}
			return state;
		}
		case types.REMOVE_TASK_TAGS: {
			const filteredTagList = _.filter(state.tags, (tag) => {
				return !_.includes(action.removedTagIds, tag.engagementTagId);
			});

			return {
				...state,
				tags: filteredTagList
			};
		}

		default:
			return state;
	}
}

export function buildTag(tag, tagGroup, taskId) {
	let taskTag = {
		colorCode: tag.colorCode,
		engagementTagGroupId: tagGroup.groupId,
		engagementTagGroupName: tagGroup.groupName,
		engagementTagId: tag.tagId,
		engagementTagName: tag.tagName,
		entityCount: 0,
		entityUIID: taskId
	};

	return taskTag;
}
